import { Box, useMediaQuery } from "@mui/material";
import { styles } from "./styles";
import backGroundMobile from "./ommuseBackgroundMobile.png";
import backGround from "./ommuseBackground.png";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { isEnterprise } from "../../theme";
import CustomButton from "../../components/CustomButton/CustomButton";

const WelcomePage: React.FC = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const enterpriseName = process.env.REACT_APP_ENTERPRISE_NAME;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    document.title = isEnterprise
      ? `Welcome - ${enterpriseName}`
      : "Welcome - OmMuse";
  }, [enterpriseName]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window && window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSignUp = () => {
    localStorage.clear();
    loginWithRedirect({
      appState: { targetUrl: "/initial-setting" },
      authorizationParams: { screen_hint: "signup" },
    });
  };

  const imgSrc = windowWidth >= 800 ? backGround : backGroundMobile;
  const margin = windowWidth >= 800 ? "100px" : "60px";

  return (
    <Box
      sx={[
        styles.container,
        {
          marginTop: "20px",
          marginBottom: "-30px",
          backgroundSize: "cover",
          backgroundPosition: "center 30%",
          backgroundImage: isEnterprise
            ? "url('/assets/images/redlight-white-Image2.jpg')"
            : `url(${imgSrc})`,
        },
      ]}
    >
      <Box sx={[styles.headerContainer, { marginLeft: margin }]}>
        <h1 style={styles.firstHeading}>
          Welcome to {isEnterprise ? enterpriseName : "OmMuse"}
        </h1>
      </Box>
      {!isAuthenticated && (
        <Box
          sx={{
            ...styles.buttonContainer,
            ...{
              marginLeft: margin,
              width: isSmallScreen ? "60vw" : "20vw",
            },
          }}
        >
          <CustomButton onClick={handleSignUp} text="Sign up" />
        </Box>
      )}
    </Box>
  );
};

export default WelcomePage;
